<template>
  <component
    :is="element"
    v-bind="$attrs"
    class="base-subheading"
    v-on="$listeners"
  >
    <slot />
  </component>
</template>

<script>
export default {
  inheritAttrs: false,
};
</script>

<script setup>
defineProps({
  element: {
    type: String,
    default: "h3",
    validator: (value) => ["h1", "h2", "h3", "h4", "h5", "h6", "p"].includes(value),
  },
});
</script>

<style lang="scss" scoped>
@import "./base-subheading.scss";
</style>
